module.exports = __webpack_public_path__ + "static/media/sku219401157.df93863b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku219401157.png
// module id = 588
// module chunks = 0